export const ACCOUNT_AUTH_LOSS_REDIRECT_KEY = "qit:account-auth-lost";

const AUTH_LOSS_SAFE_PATHS = [
    /^\/$/,
    /^\/login\/?$/,
    /^\/signin\/?$/,
    /^\/callback\/?$/,
    /^\/auth\//,
    /^\/forgot-password\/?$/,
    /^\/reset-password\/?$/,
    /^\/join-session(\/|$)/,
    /^\/join(\/|$)/,
    /^\/session(\/|$)/,
];

export const redirectToLandingAfterAuthLoss = (): void => {
    if (typeof window === "undefined") return;

    window.sessionStorage.setItem(ACCOUNT_AUTH_LOSS_REDIRECT_KEY, "1");
    const path = window.location.pathname || "/";
    if (AUTH_LOSS_SAFE_PATHS.some((pattern) => pattern.test(path))) {
        return;
    }

    window.location.replace("/");
};
